<script setup lang="ts">
import { PV } from "@/widgets";
import Icon from "~icons/pajamas/remove";

defineEmits<{
    click: [];
}>();
</script>

<template>
    <PV.Button v-tooltip.left="'Hapus'" class="p-0!" link @click="$emit('click')">
        <Icon class="text-gray-500 hover:text-red-500 hover:cursor-pointer" />
    </PV.Button>
</template>
